'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FreeSampleCarousel = exports.FREE_SAMPLE_BUTTON = exports.CAROUSEL_SELECTOR = exports.CONTAINER_SELECTOR = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _pcSlateTools = require('@process-creative/pc-slate-tools');

var _CarouselSection2 = require('./../../sections/carousel/CarouselSection');

var _ShopifySection = require('./../../sections/ShopifySection');

var _Responsive = require('./../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Products Carousel
 *    Scripts for the Products Carousel section.
 *    Product thumbs in a slick slide
 *
 *  Version:
 *    1.0.0 - 2020/05/17
 */

var CONTAINER_SELECTOR = exports.CONTAINER_SELECTOR = '[data-free-sample-carousel]';
var CAROUSEL_SELECTOR = exports.CAROUSEL_SELECTOR = '[data-free-sample-carousel-carousel]';
var FREE_SAMPLE_BUTTON = exports.FREE_SAMPLE_BUTTON = '[data-free-sample-button]';

var FreeSampleCarousel = exports.FreeSampleCarousel = function (_CarouselSection) {
  (0, _inherits3.default)(FreeSampleCarousel, _CarouselSection);

  function FreeSampleCarousel(container) {
    (0, _classCallCheck3.default)(this, FreeSampleCarousel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FreeSampleCarousel.__proto__ || Object.getPrototypeOf(FreeSampleCarousel)).call(this, container));

    _this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    _this.slick = _this.initCarousel(_this.carouselContainer);
    _this.carouselContainer.slick('refresh');

    $(document).on('click', FREE_SAMPLE_BUTTON, function () {
      return _this.carouselContainer.slick('refresh');
    });

    return _this;
  }

  (0, _createClass3.default)(FreeSampleCarousel, [{
    key: 'updateSampleCarousel',
    value: function updateSampleCarousel() {
      this.carouselContainer = $(CAROUSEL_SELECTOR);

      if (this.carouselContainer.length) {
        if (this.carouselContainer.hasClass(_CarouselSection2.CLASS_INITIALIZED)) {
          this.carouselContainer.slick('refresh');
        } else {
          this.slick = this.initCarousel(this.carouselContainer);
        }
      }
    }
  }, {
    key: 'optionOverrides',
    value: function optionOverrides() {
      return {
        infinite: true,
        autoplay: this.container.data('autoplay') == true,
        autoplaySpeed: this.container.data('autoplay-speed') * 1000 || 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        adaptiveHeight: true
      };
    }
  }]);
  return FreeSampleCarousel;
}(_CarouselSection2.CarouselSection);

// register(CONTAINER_SELECTOR, FreeSampleCarousel);